module.exports = __webpack_public_path__ + "static/media/sun-mt-fuji-japan-landscape-407039.954456ca.jpeg";